import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface MobileNavigationState {
  mobileOpen: boolean;
  isClosing: boolean;
}

interface MobileNavigationActions {
  setMobileOpen: (open: boolean) => void;
  setIsClosing: (closing: boolean) => void;
  openMobile: () => void;
  closeMobile: () => void;
  toggleMobile: () => void;
}

type MobileNavigationStore = MobileNavigationState & MobileNavigationActions;

export const useMobileNavigationStore = create<MobileNavigationStore>()(
  devtools((set, get) => ({
    // Initial state
    mobileOpen: false,
    isClosing: false,

    // Actions
    setMobileOpen: (open) =>
      set({ mobileOpen: open }, undefined, 'mobileNavigation/setMobileOpen'),
    setIsClosing: (closing) =>
      set({ isClosing: closing }, undefined, 'mobileNavigation/setIsClosing'),

    // Convenience methods
    openMobile: () =>
      set(
        { mobileOpen: true, isClosing: false },
        undefined,
        'mobileNavigation/openMobile',
      ),
    closeMobile: () =>
      set({ mobileOpen: false }, undefined, 'mobileNavigation/closeMobile'),
    toggleMobile: () => {
      const { mobileOpen } = get();
      set(
        { mobileOpen: !mobileOpen, isClosing: false },
        undefined,
        'mobileNavigation/toggleMobile',
      );
    },
  })),
);
